(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-popup"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-featured-product-v2"]) return;
  try {
    
  (function() {
    'use strict';

    let selectedVariantId = null;
    let productData = null;
    let mainGallerySwiper = null;
    let mobileSliderSwiper = null;
    let isUpdating = false;

    try {
      const productDataElement = document.getElementById('dgf-product-data');
      if (productDataElement) {
        productData = JSON.parse(productDataElement.textContent);
      }
    } catch(e) {
      console.error('❌ Error parsing product data:', e);
    }

function initMobileSlider(initialSlide, caller) {
  try {
    if (mobileSliderSwiper) {
      mobileSliderSwiper.destroy(true, true);
      mobileSliderSwiper = null;
    }

    const sliderWrapper = document.querySelector('.product-slider .swiper-wrapper');
    if (sliderWrapper) {
      sliderWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
      sliderWrapper.style.transitionDuration = '0ms';
    }

    setTimeout(function() {
      try {

        mobileSliderSwiper = new Swiper('.product-slider', {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 0,
          observer: false,
          observeParents: false,
          pagination: {
            el: '.product-slider .swiper-pagination',
            clickable: true,
          },
        });

        // Primeira tentativa
        setTimeout(function() {
          if (mobileSliderSwiper && initialSlide > 0) {
            mobileSliderSwiper.slideTo(initialSlide, 0, false);

            // Segunda tentativa caso scripts de terceiros resetem
            setTimeout(function() {
              if (mobileSliderSwiper && mobileSliderSwiper.activeIndex !== initialSlide) {
                mobileSliderSwiper.slideTo(initialSlide, 0, false);
              }
            }, 500);
          }
        }, 200);

      } catch(e) { null; }
    }, 350);
  } catch(e) { null; }
}

function initializeGallerySwipers() {
  try {
    var initialSlide = 0;
    var preSelectedCard = document.querySelector('.dgf-variant-card.selected');
    if (preSelectedCard && productData) {
      var preSelectedId = preSelectedCard.dataset.variantId;
      var preVariant = productData.variants.find(function(v) { return String(v.id) === String(preSelectedId); });
      if (preVariant && preVariant.featured_image_position) {
        initialSlide = preVariant.featured_image_position - 1;
      }
    }


    const thumbnailWrapper = document.querySelector('.thumbnail-gallery .swiper-wrapper');
    const thumbnailSlides = thumbnailWrapper ? thumbnailWrapper.children.length : 0;

    // SEM eventos no construtor
    const thumbnailGallery = new Swiper('.thumbnail-gallery', {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
      loop: thumbnailSlides > 4,
      initialSlide: initialSlide,
      navigation: {
        nextEl: '.product-thumbnail-next',
        prevEl: '.product-thumbnail-prev',
      },
      slideToClickedSlide: true,
    });

    // SEM eventos no construtor
    const mainGallery = new Swiper('.main-gallery', {
      spaceBetween: 10,
      initialSlide: initialSlide,
      navigation: {
        nextEl: '.product-gallery-next',
        prevEl: '.product-gallery-prev',
      },
      thumbs: {
        swiper: thumbnailGallery,
      },
      loop: true,
    });


    mainGallerySwiper = mainGallery;

    initMobileSlider(initialSlide, 'initializeGallerySwipers');

    setupGallerySynchronization(thumbnailGallery, mainGallery);
    setupThumbnailNavigation(thumbnailGallery, thumbnailSlides);

    return { thumbnailGallery, mainGallery };
  } catch(e) { console.error('❌ Erro no initializeGallerySwipers:', e); }
}

    function setupGallerySynchronization(thumbnailGallery, mainGallery) {
      try {
        thumbnailGallery.on('slideChangeTransitionEnd', function () {
          if (isUpdating) {
            return;
          }
          try {
            isUpdating = true;
            const activeIndex = thumbnailGallery.realIndex;
            mainGallery.slideToLoop(activeIndex, 0);
            isUpdating = false;
          } catch(e) { isUpdating = false; }
        });

        mainGallery.on('slideChangeTransitionEnd', function () {
          if (isUpdating) {
            return;
          }
          try {
            isUpdating = true;
            const activeIndex = mainGallery.realIndex;
            thumbnailGallery.slideToLoop(activeIndex, 0);
            isUpdating = false;
          } catch(e) { isUpdating = false; }
        });
      } catch(e) { null; }
    }

    function setupThumbnailNavigation(thumbnailGallery, thumbnailSlides) {
      try {
        const prevArrow = document.querySelector('.product-thumbnail-prev');
        const nextArrow = document.querySelector('.product-thumbnail-next');

        if (!prevArrow || !nextArrow) return;

        if (thumbnailSlides <= 4) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
        } else {
          thumbnailGallery.on('slideChange', function () {
            try {
              prevArrow.style.display = 'block';
              nextArrow.style.display = 'block';
              if (thumbnailGallery.isBeginning) {
                prevArrow.classList.add('swiper-button-disabled');
              } else {
                prevArrow.classList.remove('swiper-button-disabled');
              }
              if (thumbnailGallery.isEnd) {
                nextArrow.classList.add('swiper-button-disabled');
              } else {
                nextArrow.classList.remove('swiper-button-disabled');
              }
            } catch(e) { null; }
          });
        }
      } catch(e) { null; }
    }

    function updatePriceDisplay(price, comparePrice) {
      try {
        const priceNum = parseInt(price) || 0;
        const comparePriceNum = comparePrice && comparePrice !== '' ? parseInt(comparePrice) : 0;

        const priceDisplay = document.getElementById('selected-price');
        const buttonPrice = document.getElementById('button-price');
        const comparePriceDisplay = document.getElementById('compare-price');

        if (priceDisplay && priceNum) {
          priceDisplay.textContent = '$' + (priceNum / 100).toFixed(2);
        }
        if (buttonPrice && priceNum) {
          buttonPrice.textContent = '$' + (priceNum / 100).toFixed(2);
        }
        if (comparePriceDisplay) {
          if (comparePriceNum > 0 && comparePriceNum > priceNum) {
            comparePriceDisplay.textContent = '$' + (comparePriceNum / 100).toFixed(2);
            comparePriceDisplay.style.display = 'inline';
          } else {
            comparePriceDisplay.style.display = 'none';
          }
        }
      } catch(e) {
        console.error('❌ Error updating price display:', e);
      }
    }

    function selectVariantById(variantId, price, comparePrice) {
      try {
        selectedVariantId = variantId;
        updatePriceDisplay(price, comparePrice);
        slideToVariantImage(variantId);
      } catch(e) { null; }
    }

    function slideToVariantImage(variantId) {
      try {
        if (!productData) return;
        const variant = productData.variants.find(v => String(v.id) === String(variantId));
        if (!variant || !variant.featured_image_position) {
          console.warn('⚠️ Variant não encontrada ou sem featured_image_position');
          return;
        }

        const slideIndex = variant.featured_image_position - 1;

        if (mainGallerySwiper) {
          mainGallerySwiper.slideToLoop(slideIndex, 300);
        }

        if (window.innerWidth < 768) {
          initMobileSlider(slideIndex, 'slideToVariantImage');
        }

      } catch(e) { console.error('❌ Erro no slideToVariantImage:', e); }
    }

    function setupVariantSelection() {
      try {
        const variantCards = document.querySelectorAll('.dgf-variant-card');
        if (variantCards.length === 0) return;

        const firstSelected = document.querySelector('.dgf-variant-card.selected');
        if (firstSelected) {
          selectedVariantId = firstSelected.dataset.variantId;
        } else {
          const firstAvailable = variantCards[0];
          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            selectedVariantId = firstAvailable.dataset.variantId;
          }
        }

        variantCards.forEach(card => {
          try {
            card.addEventListener('click', function() {
              try {
                variantCards.forEach(c => c.classList.remove('selected'));
                this.classList.add('selected');

                const variantId = this.dataset.variantId;
                const price = this.dataset.variantPrice;
                const comparePrice = this.dataset.variantComparePrice;
            
                selectVariantById(variantId, price, comparePrice);
              } catch(e) { null; }
            });
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    function setupVariantRadioListeners() {
      try {
        const variantRadios = document.querySelectorAll('.dgf-variant-radio');
        variantRadios.forEach(radio => {
          radio.addEventListener('change', function() {
            if (this.checked) {
              updatePackOptions(this.value);
            }
          });
        });
      } catch(e) {
        console.error('❌ Error setting up variant radio listeners:', e);
      }
    }

    function setupAddToCartButton() {
      try {
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault();
            addToCart();
          });
        }
      } catch(e) {
        console.error('❌ Error setting up add to cart button:', e);
      }
    }

    function addToCart() {
      try {
        if (!selectedVariantId) {
          console.error('No variant selected');
          return;
        }

        const button = document.getElementById('add-to-cart-btn');

        if (button) {
          button.disabled = true;
          button.textContent = 'ADDING...';
        }

        const payload = JSON.stringify({
          items: [{ id: parseInt(selectedVariantId), quantity: 1 }]
        });

        const upsellEnabled = document.getElementById('dgf-upsell-popup') && typeof window.openUpsellPopup === 'function';

        function restoreButton() {
          try {
            if (button) {
              button.disabled = false;
              const buttonPriceEl = document.getElementById('button-price');
              if (buttonPriceEl) {
                button.innerHTML = 'ADD TO CART |&nbsp;<span id="button-price">' + buttonPriceEl.textContent + '</span>';
              } else {
                button.textContent = 'ADD TO CART';
              }
            }
          } catch(e) { null; }
        }

        if (upsellEnabled) {
          var xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/add.js', true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.onload = function() {
            try {
              var data = JSON.parse(xhr.responseText);
              if (xhr.status === 200 && data.items && data.items.length > 0) {
                handleCartSuccess(data);
              } else {
                console.error('Error adding product to cart:', data.message || data.description || '');
              }
            } catch(e) { null; }
            restoreButton();
          };
          xhr.onerror = function() {
            console.error('Error adding product to cart');
            restoreButton();
          };
          xhr.send(payload);
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: payload
          })
          .then(response => response.json())
          .then(data => {
            try {
              if (data.items && data.items.length > 0) {
                handleCartSuccess(data);
              } else {
                console.error('Error adding product to cart');
              }
            } catch(e) { null; }
          })
          .catch(error => {
            console.error('Error adding product to cart:', error);
          })
          .finally(restoreButton);
        }
      } catch(e) { null; }
    }

    function handleCartSuccess(data) {
      try {
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { items: data.items }
        }));

        const upsellPopup = document.getElementById('dgf-upsell-popup');
        if (upsellPopup && typeof window.openUpsellPopup === 'function') {
          window.openUpsellPopup(selectedVariantId);
          return;
        }

        const cartDrawer = document.querySelector('[data-cart-drawer]') ||
                          document.querySelector('.cart-drawer') ||
                          document.querySelector('#cart-drawer');

        if (cartDrawer) {
          if (typeof openCartDrawer === 'function') {
            openCartDrawer();
          } else if (cartDrawer.classList) {
            cartDrawer.classList.add('active', 'open');
          }
        }
      } catch(e) { null; }
    }

    function updatePackOptions(selectedValue) {
      try {
        if (!productData) return;

        const allVariants = productData.variants || [];

        const matchingVariants = allVariants.filter(variant => {
          const title = variant.title || '';
          return title.includes(selectedValue) && variant.available;
        });

        const variantOptionsContainer = document.querySelector('.dgf-variant-options');
        if (!variantOptionsContainer) return;

        variantOptionsContainer.innerHTML = '';

        matchingVariants.forEach((variant, index) => {
          const card = createVariantCard(variant, index, matchingVariants.length);
          variantOptionsContainer.appendChild(card);
        });

        setupVariantSelection();

        const newCards = variantOptionsContainer.querySelectorAll('.dgf-variant-card');
        if (newCards.length > 0) {
          const cardToSelect = newCards.length > 1 ? newCards[1] : newCards[0];
          if (cardToSelect) {
            cardToSelect.click();
            const variantId = cardToSelect.dataset.variantId;
            const price = cardToSelect.dataset.variantPrice;
            const comparePrice = cardToSelect.dataset.variantComparePrice;
            updatePriceDisplay(price, comparePrice);
          }
        }

      } catch(e) {
        console.error('❌ Error updating pack options:', e);
      }
    }

    function createVariantCard(variant, index, totalVariants) {
      try {
        const card = document.createElement('div');
        card.className = 'dgf-option-card dgf-variant-card';

        if (index === 1) {
          card.classList.add('selected', 'dgf-most-popular');
        }

        card.setAttribute('data-variant-id', variant.id);
        card.setAttribute('data-variant-price', variant.price);
        card.setAttribute('data-variant-compare-price', variant.compare_at_price || '');

        let headerText = '';
        let headerBg = '';
        if (index === 0) {
          headerText = 'DAILY SAVINGS<br>25% OFF';
          headerBg = '#06211E';
        } else if (index === 1) {
          headerText = 'MOST POPULAR<br>30% OFF';
          headerBg = '#AC853B';
        } else if (index === 2) {
          headerText = 'BEST VALUE<br>35% OFF';
          headerBg = '#06211E';
        }

        let packSize = 1;
        const title = variant.title;
        if (title.includes('2-Pack')) packSize = 2;
        else if (title.includes('3-Pack')) packSize = 3;
        else if (title.includes('4-Pack')) packSize = 4;
        else if (title.includes('5-Pack')) packSize = 5;

        const pricePerPack = variant.price / packSize / 100;

        const servings = variant.metafields?.custom?.lp_qty_servings;
        const pricePerServing = variant.metafields?.custom?.lp_prc_servings;
        const customText = variant.metafields?.custom?.lp_custom_txt;
        const redPrc = variant.metafields?.custom?.lp_red_prc;

        card.innerHTML = `
          <div class="dgf-option-header" style="background-color: ${headerBg};">
            ${headerText}
          </div>
          <div class="dgf-option-content">
            <div class="dgf-option-top">
              <div class="dgf-option-title">${title}</div>
              <div class="dgf-option-price-wrapper">
                <div class="dgf-option-price">$${pricePerPack.toFixed(2)}${packSize > 1 ? '<span class="dgf-option-ea">/ea</span>' : ''}</div>
                ${redPrc ? `<div class="dgf-option-red-price">$${redPrc}</div>` : ''}
              </div>
            </div>
            <div class="dgf-option-bottom">
              <div class="dgf-option-servings">${servings} servings</div>
              <div class="dgf-option-per-serving">(<strong>$${pricePerServing}</strong>/serving)</div>
              ${customText ? `<div class="dgf-option-custom-text">${customText}</div>` : ''}
            </div>
          </div>
        `;

        return card;
      } catch(e) {
        console.error('❌ Error creating variant card:', e);
        return document.createElement('div');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      try {
        initializeGallerySwipers();
        setupVariantSelection();
        setupVariantRadioListeners();
        setupAddToCartButton();
      } catch(e) {
        null;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-featured-product"]) return;
  try {
    
  // DGF Featured Product - Modular JavaScript with Error Handling
  (function() {
    'use strict';

    let selectedVariantId = null;
    let productData = null;

    // Get product data from JSON script tag
    try {
      const productDataElement = document.getElementById('dgf-product-data');
      if (productDataElement) {
        productData = JSON.parse(productDataElement.textContent);
      }
    } catch(e) {
      console.error('❌ Error parsing product data:', e);
    }

    // Function: Remove 6-Pack variants
    function remove6PackVariants() {
      try {
        const variantCards = document.querySelectorAll('.dgf-option-card');
        variantCards.forEach(card => {
          try {
            const title = card.querySelector('.dgf-option-title')?.textContent || '';
            if (title.includes('6-Pack')) {
              card.remove();
            }
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Initialize Gallery Swipers
    function initializeGallerySwipers() {
      try {
        const thumbnailWrapper = document.querySelector('.thumbnail-gallery .swiper-wrapper');
        const thumbnailSlides = thumbnailWrapper ? thumbnailWrapper.children.length : 0;

        // Initialize Thumbnail Gallery
        const thumbnailGallery = new Swiper('.thumbnail-gallery', {
          spaceBetween: 10,
          slidesPerView: 4,
          watchSlidesProgress: true,
          loop: thumbnailSlides > 4,
          navigation: {
            nextEl: '.product-thumbnail-next',
            prevEl: '.product-thumbnail-prev',
          },
          slideToClickedSlide: true,
        });

        // Initialize Main Gallery
        const mainGallery = new Swiper('.main-gallery', {
          spaceBetween: 10,
          navigation: {
            nextEl: '.product-gallery-next',
            prevEl: '.product-gallery-prev',
          },
          thumbs: {
            swiper: thumbnailGallery,
          },
          loop: true,
        });

        setupGallerySynchronization(thumbnailGallery, mainGallery);
        setupThumbnailNavigation(thumbnailGallery, thumbnailSlides);

        return { thumbnailGallery, mainGallery };
      } catch(e) { null; }
    }

    // Function: Setup Gallery Synchronization
    function setupGallerySynchronization(thumbnailGallery, mainGallery) {
      try {
        thumbnailGallery.on('slideChangeTransitionEnd', function () {
          try {
            const activeIndex = thumbnailGallery.realIndex;
            mainGallery.slideToLoop(activeIndex, 0);
          } catch(e) { null; }
        });

        mainGallery.on('slideChangeTransitionEnd', function () {
          try {
            const activeIndex = mainGallery.realIndex;
            thumbnailGallery.slideToLoop(activeIndex, 0);
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Setup Thumbnail Navigation
    function setupThumbnailNavigation(thumbnailGallery, thumbnailSlides) {
      try {
        const prevArrow = document.querySelector('.product-thumbnail-prev');
        const nextArrow = document.querySelector('.product-thumbnail-next');

        if (!prevArrow || !nextArrow) return;

        if (thumbnailSlides <= 4) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
        } else {
          thumbnailGallery.on('slideChange', function () {
            try {
              prevArrow.style.display = 'block';
              nextArrow.style.display = 'block';

              if (thumbnailGallery.isBeginning) {
                prevArrow.classList.add('swiper-button-disabled');
              } else {
                prevArrow.classList.remove('swiper-button-disabled');
              }

              if (thumbnailGallery.isEnd) {
                nextArrow.classList.add('swiper-button-disabled');
              } else {
                nextArrow.classList.remove('swiper-button-disabled');
              }
            } catch(e) { null; }
          });
        }
      } catch(e) { null; }
    }

    // Function: Update Price Display
    function updatePriceDisplay(price, comparePrice) {
      try {
        // Convert to numbers - handle empty strings and null
        const priceNum = parseInt(price) || 0;
        const comparePriceNum = comparePrice && comparePrice !== '' ? parseInt(comparePrice) : 0;

        const priceDisplay = document.getElementById('selected-price');
        const buttonPrice = document.getElementById('button-price');
        const comparePriceDisplay = document.getElementById('compare-price');


        if (priceDisplay && priceNum) {
          priceDisplay.textContent = '$' + (priceNum / 100).toFixed(2);
        }

        if (buttonPrice && priceNum) {
          buttonPrice.textContent = '$' + (priceNum / 100).toFixed(2);
        }

        if (comparePriceDisplay) {
          if (comparePriceNum > 0 && comparePriceNum > priceNum) {
            comparePriceDisplay.textContent = '$' + (comparePriceNum / 100).toFixed(2);
            comparePriceDisplay.style.display = 'inline';
          } else {
            comparePriceDisplay.style.display = 'none';
          }
        }
      } catch(e) {
        console.error('❌ Error updating price display:', e);
      }
    }

    // Function: Select Variant
    function selectVariantById(variantId, price, comparePrice) {
      try {
        selectedVariantId = variantId;
        updatePriceDisplay(price, comparePrice);
      } catch(e) { null; }
    }

    // Function: Setup Variant Selection
    function setupVariantSelection() {
      try {
        const variantCards = document.querySelectorAll('.dgf-variant-card');
        if (variantCards.length === 0) return;

        // Set initial selected variant
        const firstSelected = document.querySelector('.dgf-variant-card.selected');
        if (firstSelected) {
          selectedVariantId = firstSelected.dataset.variantId;
        } else {
          const firstAvailable = Array.from(variantCards).find(card => {
            try {
              const title = card.querySelector('.dgf-option-title')?.textContent || '';
              return !title.includes('6-Pack');
            } catch(e) { return false; }
          });

          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            selectedVariantId = firstAvailable.dataset.variantId;
          }
        }

        // Add click event listeners
        variantCards.forEach(card => {
          try {
            card.addEventListener('click', function() {
              try {
                // Remove selected from all cards
                variantCards.forEach(c => c.classList.remove('selected'));

                // Add selected to clicked card
                this.classList.add('selected');

                // Update variant and prices
                const variantId = this.dataset.variantId;
                const price = this.dataset.variantPrice;
                const comparePrice = this.dataset.variantComparePrice;

                selectVariantById(variantId, price, comparePrice);
              } catch(e) { null; }
            });
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Setup Variant Radio Listeners
    function setupVariantRadioListeners() {
      try {
        const variantRadios = document.querySelectorAll('.dgf-variant-radio');
        variantRadios.forEach(radio => {
          radio.addEventListener('change', function() {
            if (this.checked) {
              updatePackOptions(this.value);
            }
          });
        });

        // No need to trigger initial filter - Liquid already renders only the default variant cards
        console.log('✅ Variant radio listeners setup complete');
      } catch(e) {
        console.error('❌ Error setting up variant radio listeners:', e);
      }
    }

    // Function: Setup Add to Cart Button
    function setupAddToCartButton() {
      try {
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault();
            addToCart();
          });
        }
      } catch(e) {
        console.error('❌ Error setting up add to cart button:', e);
      }
    }

    // Function: Add to Cart
    function addToCart() {
      try {
        if (!selectedVariantId) {
          console.error('No variant selected');
          return;
        }

        const button = document.getElementById('add-to-cart-btn');

        // Disable button
        if (button) {
          button.disabled = true;
          button.textContent = 'ADDING...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: selectedVariantId, quantity: 1 }]
          })
        })
        .then(response => response.json())
        .then(data => {
          try {
            if (data.items && data.items.length > 0) {
              handleCartSuccess(data);
            } else {
              console.error('Error adding product to cart');
            }
          } catch(e) { null; }
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        })
        .finally(() => {
          try {
            if (button) {
              button.disabled = false;
              button.textContent = 'ADD TO CART';
            }
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Handle Cart Success
    function handleCartSuccess(data) {
      try {
        // Update cart count
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }

        // Open cart drawer
        const cartDrawer = document.querySelector('[data-cart-drawer]') ||
                          document.querySelector('.cart-drawer') ||
                          document.querySelector('#cart-drawer');

        if (cartDrawer) {
          if (typeof openCartDrawer === 'function') {
            openCartDrawer();
          } else if (cartDrawer.classList) {
            cartDrawer.classList.add('active', 'open');
          }
        } else {
          console.log('Product added to cart successfully');
        }

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { items: data.items }
        }));
      } catch(e) { null; }
    }

    // Function: Update Pack Options Based on Variant Selection
    function updatePackOptions(selectedValue) {
      try {
        console.log('🔄 Updating pack options for variant:', selectedValue);

        // Check if product data is available
        if (!productData) {
          console.error('❌ Product data not available');
          return;
        }

        // Get all product variants
        const allVariants = productData.variants || [];

        // Filter variants that match the selected option value and exclude 6-Pack
        const matchingVariants = allVariants.filter(variant => {
          const title = variant.title || '';
          return title.includes(selectedValue) && !title.includes('6-Pack') && variant.available;
        });

        console.log('✅ Found matching variants:', matchingVariants.length);

        // Get the variant cards container
        const variantOptionsContainer = document.querySelector('.dgf-variant-options');
        if (!variantOptionsContainer) {
          console.error('❌ Variant options container not found');
          return;
        }

        // Clear existing cards
        variantOptionsContainer.innerHTML = '';

        // Create new cards for matching variants
        matchingVariants.forEach((variant, index) => {
          const card = createVariantCard(variant, index, matchingVariants.length);
          variantOptionsContainer.appendChild(card);
        });

        // Re-setup variant selection
        setupVariantSelection();

        // Auto-select the "Most Popular" card (index 1) or first card if less than 2
        const newCards = variantOptionsContainer.querySelectorAll('.dgf-variant-card');
        if (newCards.length > 0) {
          const cardToSelect = newCards.length > 1 ? newCards[1] : newCards[0];
          if (cardToSelect) {
            // Trigger click to select and update prices
            cardToSelect.click();

            // Force update prices immediately after click
            const variantId = cardToSelect.dataset.variantId;
            const price = cardToSelect.dataset.variantPrice;
            const comparePrice = cardToSelect.dataset.variantComparePrice;

            console.log('🔄 Auto-selected card:', {
              variantId,
              price,
              comparePrice: comparePrice || 'none'
            });

            // Ensure prices are updated
            updatePriceDisplay(price, comparePrice);
          }
        }

        console.log('✅ Pack options updated successfully');

      } catch(e) {
        console.error('❌ Error updating pack options:', e);
      }
    }

    // Function: Create Variant Card
    function createVariantCard(variant, index, totalVariants) {
      try {
        const card = document.createElement('div');
        card.className = 'dgf-option-card dgf-variant-card';

        // Add selected class to "Most Popular" (index 1)
        if (index === 1) {
          card.classList.add('selected', 'dgf-most-popular');
        }

        card.setAttribute('data-variant-id', variant.id);
        card.setAttribute('data-variant-price', variant.price);
        card.setAttribute('data-variant-compare-price', variant.compare_at_price || '');

        // Determine header text and background
        let headerText = '';
        let headerBg = '';
        if (index === 0) {
          headerText = 'DAILY SAVINGS<br>25% OFF';
          headerBg = '#06211E';
        } else if (index === 1) {
          headerText = 'MOST POPULAR<br>30% OFF';
          headerBg = '#AC853B';
        } else if (index === 2) {
          headerText = 'BEST VALUE<br>35% OFF';
          headerBg = '#06211E';
        }

        // Calculate pack size
        let packSize = 1;
        const title = variant.title;
        if (title.includes('2-Pack')) packSize = 2;
        else if (title.includes('3-Pack')) packSize = 3;
        else if (title.includes('4-Pack')) packSize = 4;
        else if (title.includes('5-Pack')) packSize = 5;

        // Calculate prices
        const pricePerPack = variant.price / packSize / 100;

        // Get servings from metafields
        const servings = variant.metafields?.custom?.lp_qty_servings;
        const pricePerServing = variant.metafields?.custom?.lp_prc_servings;

        // Build card HTML
        card.innerHTML = `
          <div class="dgf-option-header" style="background-color: ${headerBg};">
            ${headerText}
          </div>
          <div class="dgf-option-content">
            <div class="dgf-option-top">
              <div class="dgf-option-title">${title}</div>
              <div class="dgf-option-price-wrapper">
                <div class="dgf-option-price">$${pricePerPack.toFixed(2)}</div>
                <div class="dgf-option-each" ${packSize === 1 ? 'style="opacity: 0;"' : ''}>(each)</div>
              </div>
            </div>
            <div class="dgf-option-bottom">
              <div class="dgf-option-servings">${servings} servings</div>
              <div class="dgf-option-per-serving">(<strong>$${pricePerServing}</strong>/serving)</div>
            </div>
          </div>
        `;

        return card;
      } catch(e) {
        console.error('❌ Error creating variant card:', e);
        return document.createElement('div');
      }
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      try {
        remove6PackVariants();
        initializeGallerySwipers();
        setupVariantSelection();
        setupVariantRadioListeners();
        setupAddToCartButton();
      } catch(e) {
        console.log('❌ DGF Featured Product: Error in initialization', e);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-img-and-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Make toggleAccordion function global
  window.toggleAccordion = function(header) {
    try {
      const content = header.nextElementSibling;
      const isActive = content.classList.contains('active');

      // Close all accordions in this section
      const sectionId = header.closest('section').id;
      const allContents = document.querySelectorAll(`#${sectionId} .dgf-accordion-content`);
      const allHeaders = document.querySelectorAll(`#${sectionId} .dgf-accordion-header`);

      allContents.forEach(item => item.classList.remove('active'));
      allHeaders.forEach(item => item.classList.remove('active'));

      // Open current accordion if it wasn't active
      if (!isActive) {
        content.classList.add('active');
        header.classList.add('active');
      }
    } catch(e) {
      console.error('Accordion toggle error:', e);
    }
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-img-and-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (window.innerWidth <= 767) {
      const mobileButton = document.querySelector('.dgf-mobile-button-wrapper');
      if (mobileButton) {
        let buttonOriginalPosition = mobileButton.offsetTop;
        let isSticky = false;

        // Get button URL and check if it's an internal section link
        const buttonLink = mobileButton.querySelector('a');
        let targetSectionId = null;

        if (buttonLink && buttonLink.href) {
          const href = buttonLink.getAttribute('href');
          // Check if href contains shopify-section pattern
          if (href.includes('#dgf-featured-product')) {
            targetSectionId = 'dgf-featured-product';
          }
        }

        function isInTargetSection() {
          try {
            if (!targetSectionId) return false;

            // Find the target section element
            const targetSection = document.getElementById(targetSectionId);
            if (!targetSection) return false;

            // Get exact section boundaries - no buffer
            const sectionTop = targetSection.offsetTop;
            const sectionBottom = targetSection.offsetTop + targetSection.offsetHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + windowHeight;

            // Check if viewport overlaps with the exact section boundaries
            return viewportBottom >= sectionTop && viewportTop <= sectionBottom;
          } catch(e) {
            return false;
          }
        }

        let scrollTimeout;
        function handleScroll() {
          try {
            // Clear previous timeout to prevent rapid fire
            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const shouldBeSticky = scrollTop > buttonOriginalPosition + 100;
              const inTargetSection = isInTargetSection();

              // Show sticky button only if should be sticky AND not in target section
              if (shouldBeSticky && !inTargetSection && !isSticky) {
                mobileButton.classList.add('dgf-mobile-sticky-button');
                isSticky = true;
              } else if ((!shouldBeSticky || inTargetSection) && isSticky) {
                mobileButton.classList.remove('dgf-mobile-sticky-button');
                isSticky = false;
              }
            }, 10); // Small delay to prevent rapid changes
          } catch(e) { null; }
        }

        window.addEventListener('scroll', handleScroll);

        // Recalculate position if window is resized
        window.addEventListener('resize', function() {
          try {
            if (window.innerWidth <= 767) {
              buttonOriginalPosition = mobileButton.offsetTop;
            } else {
              mobileButton.classList.remove('dgf-mobile-sticky-button');
              isSticky = false;
            }
          } catch(e) { null; }
        });
      }
    }
  } catch(e) { null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-subscribe-benefits"] && !Shopify.designMode) return;
  try {
    
const carouselConfig = {
  slidesPerView: 3,
  spaceBetween: 10,
  loop: true,
  centeredSlides: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  freeMode: false,
  watchSlidesProgress: true,
  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 10,
    }
  }
};


function isMobile() {
  try {
    return window.innerWidth <= 767;
  } catch (e) { null; }
}


function carouselExists() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    return carouselElement && carouselElement.swiper;
  } catch (e) { null; }
}


function initializeCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (!carouselElement) {
      return null;
    }

    if (typeof Swiper === 'undefined') {
      return null;
    }

    const carousel = new Swiper('#benefits-carousel', carouselConfig);
    return carousel;
    
  } catch (e) { null; }
}

function destroyCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (carouselElement && carouselElement.swiper) {
      carouselElement.swiper.destroy(true, true);
    }
  } catch (e) { null; }
}

function handleCarouselResize() {
  try {
    if (isMobile()) {
      if (!carouselExists()) {
        initializeCarousel();
      }
    } else {
      if (carouselExists()) {
        destroyCarousel();
      }
    }
  } catch (e) { null; }
}


function initializeMobileCarousel() {
  try {
    if (isMobile()) {
      initializeCarousel();
    }
    } catch (e) { null; }
}


function setupEventListeners() {
  try {
    window.addEventListener('resize', handleCarouselResize);
    window.addEventListener('resize', handleResponsiveScale);
  } catch (error) {null; }
}

// Função para controle dinâmico de escala
function handleResponsiveScale() {
  try {
    const windowWidth = window.innerWidth;
    const benefitsContainer = document.querySelector('#id-{{ section.id }} .benefits-container');
    
    if (!benefitsContainer) return;
    
    // Aplica escala dinâmica apenas entre 1024px e 1280px
    if (windowWidth >= 1024 && windowWidth <= 1280) {
      const benefitItems = benefitsContainer.querySelectorAll('.benefit-item');
      const benefitArrows = benefitsContainer.querySelectorAll('.benefit-arrow');
      const totalItems = benefitItems.length;
      
      if (totalItems === 0) return;
      
      // Calcula a escala baseada na largura disponível
      const containerPadding = 60; // padding das laterais + margem extra
      const availableWidth = windowWidth - containerPadding;
      const minItemWidth = 185; // largura mínima por item (aumentada para considerar setas)
      const arrowWidth = 41; // largura da seta + margens (20px + 2px + 19px margin)
      const totalArrowWidth = benefitArrows.length * arrowWidth;
      const idealTotalWidth = (totalItems * minItemWidth) + totalArrowWidth;
      
      let scale = 1;
      if (idealTotalWidth > availableWidth) {
        scale = Math.max(0.70, availableWidth / idealTotalWidth);
      }
      
      // Aplica a escala calculada
      benefitsContainer.style.transform = `scale(${scale})`;
      
      // Ajusta o container para evitar overflow
      if (scale < 1) {
        benefitsContainer.style.marginTop = `${(1 - scale) * -25}px`;
        benefitsContainer.style.marginBottom = `${(1 - scale) * -25}px`;
      }
      
    } else {
      // Remove transformações para outras resoluções
      benefitsContainer.style.transform = '';
      benefitsContainer.style.marginTop = '';
      benefitsContainer.style.marginBottom = '';
    }
  } catch (error) {
    console.warn('Erro no controle de escala responsiva:', error);
  }
}

// Função para inicializar o controle de escala
function initResponsiveScale() {
  try {
    handleResponsiveScale();
  } catch (error) {
    console.warn('Erro ao inicializar controle de escala:', error);
  }
}


function init() {
  try {
    initializeMobileCarousel();
    initResponsiveScale();
    setupEventListeners();
  } catch (e) { null; }
}

document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mothers-day-sale"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  // Quick-add ATC: AJAX add + visible feedback + nudge the existing cart
  // drawer / Rebuy SmartCart to open. Falls back to the normal form submit
  // (-> /cart) if fetch isn't available or the request errors.
  function openCart() {
    // Try every known cart-drawer trigger in this theme stack.
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (_) {}
    // Rebuy SmartCart
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      try { window.Rebuy.SmartCart.show(); return; } catch (_) {}
    }
    // Theme cart-icon click as fallback
    var bubble = document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]');
    if (bubble) bubble.click();
  }

  function attach() {
    var forms = document.querySelectorAll('form[data-mds-atc]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!('fetch' in window)) return; // fall back to native submit
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form),
        }).then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        }).then(function (r) {
          if (!r.ok) {
            btn.textContent = (r.data && r.data.description) || 'Could not add';
            setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2800);
            return;
          }
          btn.classList.add('is-added');
          btn.textContent = 'Added ✓';
          openCart();
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2200);
        }).catch(function () {
          // Network error — fall back to native form submit
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
  // (floating-redeem behavior lives in an inline <script> tag in markup so it
  //  doesn't depend on the section JS bundle attaching for this template)
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-social-impact"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Photo carousel — prev/next arrows scroll the rail by ~one slide width.
  // Disables arrow at scroll-extremes. Uses native scroll-snap so swipe still works.
  function initGallery(wrap) {
    var rail = wrap.querySelector('[data-gallery-rail]');
    var prev = wrap.querySelector('[data-gallery-prev]');
    var next = wrap.querySelector('[data-gallery-next]');
    if (!rail || !prev || !next) return;

    function slideWidth() {
      var slide = rail.querySelector('.tribe-impact__gallery-slide');
      if (!slide) return rail.clientWidth * 0.6;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var wraps = document.querySelectorAll('[data-gallery-rail-wrap]');
    wraps.forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-comingsoon-formulas"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var a = e.target.closest('[data-nr-scroll]'); if(!a) return;
  var t = document.getElementById('nr-waitlist'); if(!t) return;
  e.preventDefault(); t.scrollIntoView({ behavior:'smooth', block:'center' });
  var first = t.querySelector('input'); if(first) setTimeout(function(){ first.focus(); }, 500);
});

  } catch(e) { console.error(e); }
})();
})();
